// Global DOM components.
import React from 'react'
import ReactDOM from 'react-dom/client'
import { Router } from 'react-router-dom'

// The App.
import App from './components/App'
import history from 'utils/history'

// React Query.
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// Redux.
import { Provider } from 'react-redux'
import store from './store'

// Localization
import './i18n'

// Global CSS.
import './tailwind.css'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (failureCount >= 3) {
          return false
        }

        const status = error.response?.status

        const retryableStatuses = [500, 502, 503]
        if (!status || retryableStatuses.includes(status)) {
          return true
        }

        // Do not retry on client errors like 400, 401, 403, or 404
        return false
      }
    }
  }
})

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <Router history={history}>
        <App />
      </Router>
    </Provider>
  </QueryClientProvider>
)
